import { render, staticRenderFns } from "./PlayerList.vue?vue&type=template&id=321406a9&scoped=true"
import script from "./PlayerList.vue?vue&type=script&lang=js"
export * from "./PlayerList.vue?vue&type=script&lang=js"
import style0 from "./PlayerList.vue?vue&type=style&index=0&id=321406a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321406a9",
  null
  
)

export default component.exports